import { Routes } from '@angular/router';
import { CommonModalComponent } from './components/common-modal/common-modal.component';
import { authGuard } from './guards/auth.guard';
import { HomeComponent } from './components/pages/home/home.component';
import { UnauthenOutletsComponent } from './outlets/unauthen-outlets/unauthen-outlets.component';
import { CommonOutletsComponent } from './outlets/common-outlets/common-outlets.component';
import { LoginComponent } from './components/pages/auth/login/login.component';

export const routes: Routes = [
  // {
  //   path: '',
  //   component: UnauthenOutletsComponent,
  //   canActivate: [authGuard],
  //   children: [
  //     {
  //       path: '',
  //       component: HomeComponent,
  //       data: { showCoverImg: true },
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   component: HomeComponent,
  // },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: UnauthenOutletsComponent,
    loadChildren: () =>
      import('./components/pages/auth/auth.routes').then((r) => r.AuthRoutes),
  },
  { path: '**', redirectTo: 'auth/login', pathMatch: 'full' },
];
